// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--3VpLX";
export var years = "footer-module--years--3rRno";
export var jsconfbp = "footer-module--jsconfbp--uNYh-";
export var logo = "footer-module--logo--1khNe";